<div class="transport-registration-with-code">



    <sc-flex [vertical]="true" [stretchContent]="true">
      <sc-padding>
          <h1>{{'Code aus Voranmeldung' | translate:
              ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.headline',
              translationService.language]}}</h1>
      </sc-padding>

      <sc-flex [stretchContent]="true" [fitHeight]="true">
        <sc-flex-fitting-content>
          <sc-padding>
            <div *ngIf="!qrCodeScanEnabled">
              {{'' | translate: ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.description',
                translationService.language]}}
            </div>

            <div *ngIf="qrCodeScanEnabled">
              {{'' | translate: ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.description-with-scanning',
                translationService.language]}}
            </div>

            <h2>{{'' | translate:
                  ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.headline',
                  translationService.language]}}</h2>

            <form [formGroup]="registrationForm" class="form">
              <mat-form-field class="registration-code">
                <input matInput #focusComponent placeholder="{{'Code' | translate : ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.placeholder', translationService.language ]}}" formControlName="code" autofocus>
              </mat-form-field>
            </form>

            <app-service-response [responseMessages]="responseMessages"></app-service-response>

            <mat-spinner class="progressSpinner" *ngIf="checkCodeActive"></mat-spinner>

          </sc-padding>
        </sc-flex-fitting-content>

        <div *ngIf="qrCodeScanEnabled">
          <sc-padding>
            <div class="qrcode">
              <img src="/assets/default/terminal_scan_qrcode_2.svg">
              <div class="diode">
                <div class="laser"></div>
              </div>
            </div>
          </sc-padding>
        </div>

      </sc-flex>

      <div *ngIf="newRegistrationEnabled">
          <p>{{'' | translate:
              ['tmc-yard.widgets.registration-terminal.transport-registration-with-code.code.subline',
              translationService.language]}}</p>
      </div>

    </sc-flex>


</div>
